import { z } from "zod";
import { planSchema } from "./plan";
import { cicloFacturacionSchema } from "./enums";

/**
 * UI-specific schemas derived from domain schemas
 * These are for component props and local UI state
 */

/**
 * Pricing feature item for display
 */
export const pricingFeatureSchema = z.object({
	text: z.string(),
	included: z.boolean(),
	indented: z.boolean().optional(),
});
export type PricingFeature = z.infer<typeof pricingFeatureSchema>;

/**
 * Pricing card component props schema
 */
export const pricingCardPropsSchema = z.object({
	plan: planSchema,
	billingCycle: cicloFacturacionSchema,
	isCurrentPlan: z.boolean().optional().default(false),
	onSelect: z.function().args().returns(z.void()),
});
export type PricingCardProps = z.infer<typeof pricingCardPropsSchema>;

/**
 * Plan summary for modals
 */
export const planSummarySchema = z.object({
	planName: z.string(),
	billingCycle: cicloFacturacionSchema,
	price: z.number(),
	currency: z.string(),
});
export type PlanSummary = z.infer<typeof planSummarySchema>;
